import { CollectionRow } from './CollectionRow';

export default CollectionRow;
